import { compose, hoistStatics } from 'recompose';
import mlHelper from '../../helpers/ml.helper';
import Widgets from './Widgets';

const enhance = compose(
  mlHelper.core,
);

export default hoistStatics(enhance)(Widgets);



// WEBPACK FOOTER //
// ./src/views/widgets/index.js